import { render, staticRenderFns } from "./ModalListadoPermisos.vue?vue&type=template&id=254bf2f0&scoped=true&"
import script from "./ModalListadoPermisos.vue?vue&type=script&lang=js&"
export * from "./ModalListadoPermisos.vue?vue&type=script&lang=js&"
import style0 from "./ModalListadoPermisos.vue?vue&type=style&index=0&id=254bf2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254bf2f0",
  null
  
)

export default component.exports